import { IMasterAccount } from '../../interfaces/master-account/master-account.interface';

export abstract class AbstractMasterAccountService {
  abstract getMasterAccountBalanceInformation(
    corrsRoutingNumber: string | undefined
  ): Promise<IMasterAccount | undefined>;
}
